import { render, staticRenderFns } from "./fieldLegend.vue?vue&type=template&id=e35dc67c&scoped=true"
import script from "./fieldLegend.vue?vue&type=script&lang=js"
export * from "./fieldLegend.vue?vue&type=script&lang=js"
import style0 from "./fieldLegend.vue?vue&type=style&index=0&id=e35dc67c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35dc67c",
  null
  
)

export default component.exports